import React from "react";
import { Row, Col } from "antd";

/**
 * Tab navigation bar for the customer drawer (Add and Edit).
 * Renders the pill-style tabs row with icon + label per tab.
 */
const CustomerTabBar = ({
  retailCustomerTabs,
  activeTab,
  activeTabName,
  setActiveTab,
  setActiveTabName,
  customerForm,
  formDataCache,
  setFormDataCache,
  customerConfigData,
  isNriBilling,
  iconMap,
  isPanCustomer,
  isPanUpdateMode,
  retailCustomerGroups,
}) => {
  return (
    <Row
      style={{
        backgroundColor: "#f5f5f5",
        padding: "6px",
        borderRadius: "8px",
        marginTop: "2vh",
        height: "8vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      {retailCustomerTabs
        .filter((tab) => tab.visible)
        .sort((a, b) => a.order - b.order)
        .map((tab) => {
          const isActive = tab.id === activeTab;
          const isDisabled = tab.name.toLowerCase() === "business" && (!customerConfigData?.b2bSettings?.enableB2BBilling || isNriBilling);

          return (
            <Col
              key={tab.id}
              onClick={async () => {
                if (isDisabled) return;
                const currentValues = await customerForm.getFieldsValue();
                const updatedCache = {
                  ...formDataCache,
                  [activeTab]: currentValues,
                };
                setFormDataCache(updatedCache);

                if (tab.name?.toLowerCase().includes("business")) {
                  const allCached = Object.values(updatedCache).reduce((acc, v) => ({ ...acc, ...v }), {});
                  const hasGst = Object.entries(allCached).some(([k, v]) => {
                    if (k.toLowerCase().includes("gst") && v?.toString().trim()) return true;
                    if (/^group_\d+$/.test(k) && typeof v === "object" && v) {
                      return Object.entries(v).some(([fk, fv]) => fk.toLowerCase().includes("gst") && fv?.toString().trim());
                    }
                    return false;
                  });
                  const hasPan = Object.entries(allCached).some(([k, v]) => {
                    if (k.toLowerCase().startsWith("pan") && v?.toString().trim()) {
                      return true;
                    }
                    if (/^group_\d+$/.test(k) && typeof v === "object" && v) {
                      return Object.entries(v).some(([fk, fv]) => fk.toLowerCase().startsWith("pan") && fv?.toString().trim());
                    }
                    return false;
                  });
                  if (!hasGst && hasPan && isPanCustomer) {
                    const contactTabIds = retailCustomerTabs.filter((t) => t.name?.toLowerCase().includes("contact")).map((t) => t.id);
                    const contactGroups = (retailCustomerGroups || []).filter((g) => contactTabIds.includes(g.tabId) && g.name?.toLowerCase().includes("address"));
                    const businessTabIds = retailCustomerTabs.filter((t) => t.name?.toLowerCase().includes("business")).map((t) => t.id);
                    const businessGroups = (retailCustomerGroups || []).filter((g) => businessTabIds.includes(g.tabId) && g.name?.toLowerCase().includes("address"));
                    let contactAddressData = null;
                    for (const cg of contactGroups) {
                      const groupData = updatedCache[contactTabIds[0]]?.[cg.id] || allCached[cg.id];
                      if (groupData && typeof groupData === "object" && Object.values(groupData).some((v) => v?.toString().trim())) {
                        contactAddressData = groupData;
                        break;
                      }
                    }
                    if (contactAddressData && businessGroups.length > 0) {
                      const businessTabCache = updatedCache[tab.id] || {};
                      for (const bg of businessGroups) {
                        const existingBiz = businessTabCache[bg.id];
                        const hasExistingData = existingBiz && typeof existingBiz === "object" && Object.values(existingBiz).some((v) => v?.toString().trim());
                        if (!hasExistingData) {
                          businessTabCache[bg.id] = { ...contactAddressData };
                        }
                      }
                      updatedCache[tab.id] = businessTabCache;
                      setFormDataCache({ ...updatedCache });
                    }
                  }
                }

                if (updatedCache[tab.id]) {
                  customerForm.setFieldsValue(updatedCache[tab.id]);
                }
                setActiveTab(tab.id);
                setActiveTabName(tab.name);
              }}
              style={{
                flex: 1,
                padding: "6px 0",
                borderRadius: "6px",
                backgroundColor: isActive ? "#fff" : "transparent",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: isActive ? "#000" : "#8c8c8c",
                fontWeight: isActive ? 600 : 500,
                boxShadow: isActive ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
                transition: "all 0.2s ease",
              }}
            >
              <span style={{ marginRight: 6 }}>{iconMap[tab.icon]}</span>
              {tab.name}
            </Col>
          );
        })}
    </Row>
  );
};

export default CustomerTabBar;
